var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 7.83434C8.00521 7.83434 8.82005 7.01949 8.82005 6.01434C8.82005 5.00918 8.00521 4.19434 7.00005 4.19434C5.9949 4.19434 5.18005 5.00918 5.18005 6.01434C5.18005 7.01949 5.9949 7.83434 7.00005 7.83434Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1117 4.95283C3.26087 -0.0988398 10.745 -0.0930063 11.8884 4.95866C12.5592 7.92199 10.7159 10.4303 9.10003 11.982C7.92753 13.1137 6.07253 13.1137 4.8942 11.982C3.2842 10.4303 1.44087 7.91616 2.1117 4.95283Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.763859445ac6d07ca68738196df4ee1b.svg";
export { ForwardRef as ReactComponent };